import { Reducer } from 'redux'
import { ACCOUNT_STATEMENT_ACTIONS } from './const'
import { ActionTypes, State, StateFlippers } from './types'

// TODO(benedictkhoo): set type after domain stores are merged into common stores
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {}

export const accountStatement: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_STATEMENT_ACTIONS.SET_FLIPPERS: {
      const flippers: Partial<StateFlippers> = {}

      if (state && action.flippers.size > 0) {
        action.flippers.forEach((value, key) => {
          flippers[key] = value
        })
      }

      return {
        ...state,
        ...flippers,
      }
    }
    default:
      return state
  }
}
